import { SET_ROOM } from '../../../react/features/base/conference/actionTypes';
import MiddlewareRegistry from '../../../react/features/base/redux/MiddlewareRegistry';
import { configureInitialDevicesByWildix } from '../base/devices/actions.web';
/**
 * Implements the entry point of the middleware of the xbees/base/conference.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    switch (action.type) {
        case SET_ROOM: {
            store.dispatch(configureInitialDevicesByWildix());
            break;
        }
    }
    return next(action);
});
